import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";

import { StyledInputWrapper } from "../../Styled";

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
}

export const SearchInput = ({ value, onChange }: SearchInputProps) => {
    return (
        <StyledInputWrapper>
            <Input
                size="large"
                placeholder="Пошук за ім'ям або номером"
                value={value}
                addonAfter={<SearchOutlined />}
                onChange={(e) => onChange(e.target.value)}
                allowClear
            />
        </StyledInputWrapper>
    );
};
